import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HomeMaterialModule } from './home-material.module';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { AppCommonModule } from '../common/common.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CoreTranslationModule } from '../app.module';
import { PipesModule } from "../core/pipes/pipes.module";

@NgModule({
    declarations: [
        HomeComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HomeRoutingModule,
        HomeMaterialModule,
        AppCommonModule,
        CarouselModule,
        CoreTranslationModule,
        PipesModule
    ]
})
export class HomeModule { }
